// Get the base functions for handling the nav buttons
import {
    useNavButtons
} from "@/../../library/compFunctions/useNavButtons.js";
import {
    ref,
    watch,
    onMounted
} from "vue"

export function useWorkflowNav() {
    // Get the functions to control the navigation bar
    const {
        config,
        add,
        remove,
        removeAll,
        enable,
        disable
    } = useNavButtons();

    // Set the mode of the workflow navigation bar
    let mode = ref(null)

    // Nav Bar Setup for the welcome screen
    const welcomeSetup = () => {
        console.log("RUNNING THE WELCOME SETUP")
        removeAll()
        add("new")
        add("edit")
        add("close")
        console.log("%%%%%%% WELCOME SETUP FUNCTIOn")
    }

    // Nav Bar Setup for creating a new item
    const createSetup = () => {
        removeAll()
        add("save")
        disable("save")
        add("cancel")
    }
    
    // Nav Bar Setup with Approval
    const approveSetup = () => {
        removeAll()
        add("approve")
        add("save")
        disable("approve")
        disable("save")
        add("cancel")
    }

    // Enable the save button
    const saveOK = () => {
        removeAll()
        add("save")
        add("cancel")
    }

    // Enable the approve button
    const approveOK = () => {
        console.log(`&&&^&*^*&*& APPROVE OK Function`)
        removeAll()
        add("approve")
        add("save")
        add("cancel")
    }

    watch(mode, () => {
        console.log("MODE UPDATE", mode)
        if (mode.value === "welcome") welcomeSetup()
        if (mode.value === "create" || mode.value === "popup_create" || mode.value === "popup_edit" || mode.value === "edit") createSetup()
        if (mode.value === "approve_create" || mode.value === "popup_approve_create" || mode.value === "popup_approve_edit" || mode.value === "approve_edit") approveSetup()
        if (mode.value === "saveOK") saveOK()
        if (mode.value === "approveOK") approveOK()
    })

    // Define the welcome state for the navigation bar


    return {
        config,
        mode
    }



}